<template>
  <div class="account-currency">
    <label>{{ title }}</label>
    <div class="calculator-select">
      <select :id="selectName" v-model="inputDetails[selectName]" :data-live-search="selectName== 'asset' ? 'true' : 'false'" @change="changeHandler">
        <option :ref="option.value" class="calculator-option" v-for="(option, index) in options" :value="option.value" :data-index="index" :key="index">{{ option.label }}</option>
      </select>
    </div>
  </div>
</template>

<script>
	export default {
		name: "calculatorSelect",
		updated : function(){
			$('#' + this.selectName).selectpicker('refresh');
		},
		mounted : function(){
			this.inputDetails[this.selectName] = this.options[0].value ;
			var $select = $('#' + this.selectName) ;
			$select.selectpicker({
        size: '4',
        noneSelectedText: this.$getContent('nothing_selected', 'Nothing selected'),
        noneResultsText: this.$getContent('no_results_matched', 'No results matched {0}')
      });

			if(typeof topBarLoaded != 'undefined' && $select.attr('id') == 'feeCurrency'){
				var that = this ;
				topBarLoaded.done( function ( results ) {
					if(results.Customer){
						window.userCurrentAccount = results.Customer.Accounts[0].Currency ;
						$select.find('option').each(function(){
							if($(this).attr('value') == window.userCurrentAccount){
								that.inputDetails['feeCurrency'] = $(this).attr('value') ;
							}
						});
					}
				});
			}
		} ,
		props : ['title' , 'selectName' , 'options' , "inputDetails", 'changeHandler']
	}
</script>

<style lang="scss">
  .account-currency{
    .bootstrap-select {
      width: 100% !important;
      font-family: Roboto;
      font-size: 20px;
      border: none;
      font-weight: 300;
      border: none;
      background-color: #353535;
      .btn{
        line-height: 1.42857;
        height: auto;
      }
      &.open{
        z-index: 801;
      }
      span{
        font-weight: 300;
      }
      .dropdown-toggle , .dropdown-toggle:hover , .dropdown-menu{
        background-color: #353535 !important;
        top: inherit;
        border:none;
        color:#fff ;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 20px;
        font-weight: 300;
        width: 100%;
      }
      .dropdown-toggle:focus{
        outline: 0 !important;
      }
      .dropdown-toggle{
        padding-right: 15px;
        padding-left: 15px;
        border-radius: 6px;
        .filter-option{
          position: static;
          right:initial;
        }
        &:hover{
          .caret{
            border-color:#ffc900;
          }
        }
      }
      .dropdown-menu{
        &::-webkit-scrollbar {
          position: relative;
          left:-100px;
          width: 5px;
          height: 68px;
          border-radius: 2.5px;
          background-color: #494949;
        }

        &::-webkit-scrollbar-track {
          background: #353535;
        }

        &::-webkit-scrollbar-thumb {
          margin-right: 5px;
          background-color: #494949;
        }

        ::-webkit-scrollbar-track-piece {
          background-color: transparent !important;
        }

        &.inner{
          border-right: 11px #353535 solid;
          max-height: 220px !important;
        }
        .bootstrap-select.btn-group .dropdown-menu li a span.text{
          line-height: 30px;
        }

        li[data-original-index="0"]{
          display: none;
        }

        li a{
          color:#fff !important; ;
          line-height: 39px;
          background: inherit !important;
          font-size: 20px !important;
          padding: 3px 20px !important;
          &:hover , &:focus{
            background: transparent;
            outline: 0;

          }
          &:hover{
            color:#ffc900 !important;
            font-weight: bold;
          }
        }
        .inner:not(:hover){
          li.selected a{
            color:#ffc900 !important;
          }
        }

      }

      &.bootstrap-select.open{
        .dropdown-menu.open{
          padding-top: 10px;
          margin-top: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          -webkit-box-shadow: 0 6px 12px rgba(0,0,0,0.175) !important;
          box-shadow: 0 6px 12px rgba(0,0,0,0.175) !important;
          max-height: 280px !important;
          border-bottom-left-radius: 7px;
          border-bottom-right-radius: 7px;

          .bs-searchbox{
            padding: 4px 8px;
            .form-control{
              margin-bottom: 0;
              position: absolute;
              left: 0;
              right: 0;
              width: 96%;
              margin: 0 auto;
              top: 3px;
              background-color: #353535;
              border: 1px solid #5b5b5b;
              color: #fff;
              outline: none;
              line-height: 36px;
              padding-left: 10px;

              &:focus{
                border-color: #808080;
              }
            }
          }
          .no-results{
            padding: 3px;
            background: inherit;
            padding-left: 14px;
            font-size: 16px;
            color: #d8d8d8;
            margin: 0 5px;
            white-space: nowrap;
          }
        }
        .dropdown-toggle.btn{
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom: solid 1px #4e4e4e;

        }
      }

      .caret{
        border: solid #999999;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        background-image: none;
        width: 0;
        .rtl &{
          right: auto !important;
          left: 12px;
        }
      }
      &:not(.open){
        .caret{
          top: 45%;
        }

      }
      &.open{
        .caret{
          transform: rotate(-135deg);
          -webkit-transform: rotate(-135deg);
        }


      }
    }

    #asset + .bootstrap-select{
      &.bootstrap-select.open {
        .dropdown-menu.open {
          padding-top: 50px;
        }
        .dropdown-toggle.btn{
          border-bottom: none;
        }
      }
    }
    }

</style>



// WEBPACK FOOTER //
// src/components/calculatorInputs/calculatorSelect.vue